import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  h4 {
    margin: 0;
  }

  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .titleContainer, .buttonsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .buttonsContainer {
    justify-content: center;
  }

  @media only screen and (max-width: 720px) {
    flex-direction: column;
    align-items: stretch;

    .buttonsContainer {
      margin-top: 16px;
    }
  }
`;

export const starBtnStyle = {
  marginRight: -30,
};

export const sponsorBtnStyle = {
  marginBottom: -3,
};
